// extracted by mini-css-extract-plugin
export default {"table__td":"AssetsList_table__td__bBOr5","table__assetList__icon":"AssetsList_table__assetList__icon__3ut9F"};